import { tvUrls } from '@/configs/endpoints'
import api from '@/plugins/api'
import { tvIconByTpId, tvProviders, SUCCESS_CODES } from '@/configs/constants'

const defaultTvIcon = service => (service === tvProviders.megogo ? 'megogo.webp' : 'promo.webp')

const deviceIconByType = {
  1: require('@/assets/images/screens/tv.svg'),
  2: require('@/assets/images/screens/tv-box.svg'),
  3: require('@/assets/images/screens/mobile.svg'),
  4: require('@/assets/images/screens/tablet.svg'),
  5: require('@/assets/images/screens/laptop.svg')
}

const inflightChannelRequests = {}

export default {
  state: () => ({
    statusTv: {},
    tariffTv: [],
    channelsTv: {},
    myDevices: [],
    isLoading: ''
  }),
  mutations: {
    SET_DATA_TV(state, data) {
      Object.entries(data).forEach(entry => {
        state[entry[0]] = entry[1]
      })
    }
  },
  actions: {
    async getTVInfo({ commit }) {
      const response = await api.get(tvUrls.status)
      if (response?.code === 200) {
        commit('SET_DATA_TV', { statusTv: response.data })
      }
      return response
    },
    async changeTvAccountPassword(context, payload) {
      try {
        return await api.patch(tvUrls.status, { body: payload })
      } catch (error) {
        console.error('Failed to change tv account password:', error)
      }
    },
    async getTVTariff({ commit }) {
      try {
        commit('SET_DATA_TV', { isLoading: true })
        const response = await api.get(tvUrls.tariffs_all)
        const tariffTv = response.data
          .map(tvTariff => ({
            ...tvTariff,
            icon: tvIconByTpId[tvTariff.id] || defaultTvIcon(tvTariff.service)
          }))
          .toSorted((a, b) => a.count_channels - b.count_channels)
        commit('SET_DATA_TV', { tariffTv })
      } catch (error) {
        console.error('Failed to get tv tariffs:', error)
      } finally {
        commit('SET_DATA_TV', { isLoading: false })
      }
    },
    async getTVChannels({ commit, state }, tariffId) {
      if (!tariffId) return
      if (state.channelsTv?.[tariffId]) return state.channelsTv[tariffId]
      if (inflightChannelRequests[tariffId]) return inflightChannelRequests[tariffId]

      const request = (async () => {
        try {
          const response = await api.get(tvUrls.channels(tariffId))
          const data = response?.data
          const channels = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : []
          commit('SET_DATA_TV', { channelsTv: { ...state.channelsTv, [tariffId]: channels } })
          return channels
        } catch (error) {
          console.error('Failed to get tv channels:', error)
        } finally {
          delete inflightChannelRequests[tariffId]
        }
      })()

      inflightChannelRequests[tariffId] = request
      return request
    },
    async getScreens({ commit }) {
      commit('SET_DATA_TV', { isLoading: true })
      const response = await api.get(tvUrls.devices)
      response.data.forEach(item => {
        item.icon = deviceIconByType[Number(item.type)]
      })
      commit('SET_DATA_TV', { myDevices: response.data, isLoading: false })
    },
    async removeScreen({ commit, state }, payload) {
      try {
        const response = await api.delete(tvUrls.device(payload.id))
        if (SUCCESS_CODES.includes(response?.code)) {
          commit('SET_DATA_TV', { myDevices: state.myDevices.filter(item => item.id !== payload.id) })
          return true
        }
        return false
      } catch (error) {
        console.error('Failed to remove device:', error)
      }
    },
    async addTvScreenPost(context, payload) {
      try {
        return await api.post(tvUrls.devices, { body: payload })
      } catch (error) {
        console.error('Error while new device adding:', error)
      }
    }
  },
  getters: {
    getTVTariffById: state => id => (id == null ? undefined : state.tariffTv.find(t => t.id === id))
  }
}
